module.exports = function() {
  return new Worker(__webpack_public_path__ + "fc69cb940a16512baa0d.worker.js");
};